import React from 'react';
import {
  ProductPageCustomisation,
  ProductType,
  QuoteProduct
} from '../CommonTypes';
import Product from './Product';
import { getQuotedPrice } from '../ProductMethods';
import { ProductTypes } from '../../../consts/Common';

type ProductsProps = {
  products: ProductType[];
  cms: ProductPageCustomisation;
  quoteProducts?: QuoteProduct[];
  addOrRemoveProduct: (productTypeCode: string) => void;
  culture: string;
  showKeyBenefits: boolean;
  showQuotedPrice: boolean;
  showKeyBenefitsInProductCard?: boolean;
};

const Products = ({
  products,
  cms,
  quoteProducts,
  addOrRemoveProduct,
  culture,
  showKeyBenefits,
  showQuotedPrice,
  showKeyBenefitsInProductCard
}: ProductsProps): JSX.Element => {
  const selectedParentIds = products
    .filter((p) => p.isSelected || p.isPurchased)
    .map((p) => p.parentProductTypeId);

  return (
    <div className='form'>
      <div className='flex-row'>
        {products.map((product: ProductType, i) => {
          const quotePrice = getQuotedPrice(product, quoteProducts ?? []);

          const isGapProductInCooloffPeriod = () => {
            if (product.productTypeId === ProductTypes.Gap && quoteProducts) {
              const gapQuoteProduct = quoteProducts.find(
                (qp) => qp.productTypeId === product.productTypeId
              );

              if (gapQuoteProduct?.createdOn) {
                const gapDateTime = new Date(gapQuoteProduct.createdOn);

                const coolOffDateTime = gapDateTime.setDate(
                  gapDateTime.getDate() + 1
                );

                const dateTimeNow = new Date().getTime();

                return dateTimeNow < coolOffDateTime;
              }
            }

            return false;
          };

          return (
            <div key={`product-${i}`} className='flex-column'>
              <Product
                key={`product-${i}`}
                id={product.productTypeCode}
                title={product.productName}
                isSelected={product.isSelected}
                addOrRemoveProduct={addOrRemoveProduct}
                showMoreItems={
                  cms.productTypeCustomisation.find(
                    (p) => p.productType == product.productTypeId
                  )?.seeMoreItems
                }
                synopsisText={
                  cms.productTypeCustomisation.find(
                    (p) => p.productType == product.productTypeId
                  )?.synopsisText
                }
                showQuotedPrice={showQuotedPrice && quotePrice !== undefined}
                noOfInstallments={quotePrice?.noOfInstallments}
                paymentMethod={quotePrice?.paymentMethod}
                annualPrice={quotePrice?.totalPrice}
                monthlyPrice={quotePrice?.monthlyPrice}
                isPurchased={product.isPurchased}
                isDisabled={selectedParentIds.some(
                  (cl) => cl == product.parentProductTypeId
                )}
                showCooloffWarning={isGapProductInCooloffPeriod()}
                cooloffWarningText={
                  cms.productTypeCustomisation.find(
                    (p) => p.productType == product.productTypeId
                  )?.gapCoolOffWarning
                }
                culture={culture}
                showKeyBenefits={showKeyBenefits}
                showKeyBenefitsInProductCard={
                  cms.productTypeCustomisation.find(
                    (p) => p.productType == product.productTypeId
                  )?.showKeyBenefitsInProductCard &&
                  showKeyBenefitsInProductCard
                }
                hideRemovePlanLink={products.length === 1}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Products;
